/**
 * What start-up is waiting for, in plain words, for the "Can't reach the server" screen.
 *
 * On 15 and 16 October 2026 the owner's phone froze there and nobody could tell which step had
 * stopped. This keeps the step and when it began, and the screen shows it in small print, so one
 * screenshot says where it is stuck. No tokens, no personal data: only the step's name and times.
 */
const trace = { step: null, since: null, events: [] };

export const STEPS = {
  signIn: 'your sign-in',
  account: 'your account',
  role: 'your role',
};

export const markStartup = (step) => {
  trace.step = step;
  trace.since = Date.now();
};

// Something worth knowing that happened along the way (for example the lock being taken over)
export const noteStartup = (event) => {
  trace.events.push(event);
  if (trace.events.length > 5) trace.events.shift();
};

export const startupTrace = () => ({ ...trace, events: [...trace.events] });

// The browser's own lock table for the sign-in lock: how many pages hold it, and how many wait
export const signInLockState = async (locks = (typeof navigator !== "undefined" ? navigator.locks : undefined)) => {
  if (!locks?.query) return null;
  try {
    const { held = [], pending = [] } = await locks.query();
    const isSignIn = (l) => /^lock:sb-.*-auth-token$/.test(l.name || '');
    return { held: held.filter(isSignIn).length, waiting: pending.filter(isSignIn).length };
  } catch {
    return null;
  }
};

// One line for the screen, e.g. "Waiting for your sign-in for 23 s · lock held 1, waiting 1 · main.fd2c8798"
export const describeStartup = (now = Date.now(), lock = null, build = buildName()) => {
  const parts = [];
  if (trace.step) parts.push(`Waiting for ${trace.step} for ${Math.round((now - trace.since) / 1000)} s`);
  if (lock) parts.push(`lock held ${lock.held}, waiting ${lock.waiting}`);
  if (trace.events.length) parts.push(trace.events.join(', '));
  if (build) parts.push(build);
  return parts.join(' · ');
};

const buildName = () => {
  try {
    const src = [...document.scripts].map((s) => s.src).find((s) => /\/static\/js\/main\.[a-z0-9]+\.js/.test(s));
    return src ? src.match(/main\.[a-z0-9]+/)[0] : null;
  } catch {
    return null;
  }
};
